import React, { useEffect, useState } from 'react';
import {
  Row,
  Col,
  FormInput,
  FormRadioGroup,
  FormGroup,
  Input,
  InPageAlert,
  Heading,
} from '@snsw/react-component-library';
import { isEmpty, isNumeric, validateExt } from 'shared/utils/Validation';
import { RadioOrDropdownSelector } from 'shared/components/selector/RadioOrDropdownSelector';
import { radioOptionsYesNo } from 'shared/constants/constants';
import styles from '../PlantItemDetails.module.scss';
import { InspectionDocumentsUpload } from '../InspectionDocumentsUpload';
import moment from 'moment';
import { RefData } from 'plantItemNew/constants/refData';
import { PlantItemDetailsPage } from 'plantItemNew/constants/plantItemDetailsPage';

export const AmusementDeviceDetails = React.forwardRef((props, ref) => {
  const { value = {}, onChange = () => {}, applicationId, refData = {}, onErrorChange = () => {} } = props;
  const {
    name: savedName = '',
    deviceClass: savedDeviceClass = '',
    typeOfAmusementDevice: savedTypeOfAmusementDevice = '',
    otherTypeOfAmusementDevice: savedOtherTypeOfAmusementDevice = '',
    mobilityType: savedMobilityType = '',
    electricalInstallation: savedElectricalInstallation = '',
    operatingPower: savedOperatingPower = '',
    otherOperatingPower: savedOtherOperatingPower = '',
    maxSpeed: savedMaxSpeed = '',
    maxAcceleration: savedMaxAcceleraton = '',
    maxResolvingSpeed: savedMaxResolvingSpeed = '',
    maxHeightPatron: savedMaxHeightPatron = '',
    maxPatronSupportUnits: savedMaxPatronSupportUnits = '',
    maxAdultPatronsPerSupport: savedMaxAdultPatronsPerSupport = '',
    maxChildPatronsPerSupport: savedMaxChildPatronsPerSupport = '',
    minAgeUnAccompaniedPatron: savedMinAgeUnAccompaniedPatron = '',
    minAgeAccompaniedPatron: savedMinAgeAccompaniedPatron = '',
    minPatronHeight: savedMinPatronHeight = '',
    electricalInspectionDetails: savedElectricalInspectionDetails = {},
    engineerInspectionDetails: savedEngineerInspectionDetails = {},
    attachments: savedAttachments = [],
  } = value;

  const [name, setName] = useState(savedName);
  const [deviceClass, setDeviceClass] = useState(savedDeviceClass);

  const [typeOfAmusementDevice, setTypeOfAmusementDevice] = useState(savedTypeOfAmusementDevice);
  const [otherTypeOfAmusementDevice, setOtherTypeOfAmusementDevice] = useState(savedOtherTypeOfAmusementDevice);
  const [mobilityType, setMobilityType] = useState(savedMobilityType);
  const [electricalInstallation, setElectricalInstallation] = useState(savedElectricalInstallation);
  const [operatingPower, setOperatingPowwer] = useState(savedOperatingPower);
  const [otherOperatingPower, setOtherOperatingPower] = useState(savedOtherOperatingPower);

  const [maxSpeed, setMaxSpeed] = useState(savedMaxSpeed);
  const [maxAcceleration, setMaxAcceleration] = useState(savedMaxAcceleraton);
  const [maxResolvingSpeed, setMaxResolvingSpeed] = useState(savedMaxResolvingSpeed);

  const [maxHeightPatron, setMaxHeightPatron] = useState(savedMaxHeightPatron);
  const [maxPatronSupportUnits, setMaxPatronSupportUnits] = useState(savedMaxPatronSupportUnits);
  const [maxAdultPatronsPerSupport, setMaxAdultPatronsPerSupport] = useState(savedMaxAdultPatronsPerSupport);
  const [maxChildPatronsPerSupport, setMaxChildPatronsPerSupport] = useState(savedMaxChildPatronsPerSupport);
  const [minAgeUnAccompaniedPatron, setMinAgeUnAccompaniedPatron] = useState(savedMinAgeUnAccompaniedPatron);
  const [minAgeAccompaniedPatron, setMinAgeAccompaniedPatron] = useState(savedMinAgeAccompaniedPatron);
  const [minPatronHeight, setMinPatronHeight] = useState(savedMinPatronHeight);

  const [attachments, setAttachments] = useState(savedAttachments);
  const [electricalInspectionDetails, setElectricalInspectionDetails] = useState(savedElectricalInspectionDetails);
  const [engineerInspectionDetails, setEngineerInspectionDetails] = useState(savedEngineerInspectionDetails);

  const [showErrors, setShowErrors] = useState(false);
  const [errors, setErrors] = useState({});
  const [errors2, setErrors2] = useState({});

  const [errorSummary, setErrorSummary] = useState([]);
  const [errorSummary2, setErrorSummary2] = useState([]);
  const [electricalUploadErrorSummary, setElectricalUploadErrorSummary] = useState([]);
  const [engineersUploadErrorSummary, setEngineersUploadErrorSummary] = useState([]);

  useEffect(() => {
    let attachments = electricalInspectionDetails?.attachments || [];
    if (engineerInspectionDetails?.attachments) {
      attachments = attachments.concat(engineerInspectionDetails.attachments);
    }
    setAttachments(attachments);
  }, [electricalInspectionDetails, engineerInspectionDetails]);

  const validators = [
    {
      fieldName: 'name',
      fieldValue: name,
      isValid: (v) => !isEmpty(v),
      errorMessage: () => 'Please enter details',
    },
    {
      fieldName: 'deviceClass',
      fieldValue: deviceClass,
      isValid: (v) => !isEmpty(v),
      errorMessage: () => 'Please select an option',
    },
    {
      fieldName: 'mobilityType',
      fieldValue: mobilityType,
      isValid: (v) => !isEmpty(v),
      errorMessage: () => 'Please select an option',
    },
    {
      fieldName: 'electricalInstallation',
      fieldValue: electricalInstallation,
      isValid: (v) => !isEmpty(v),
      errorMessage: () => 'Please select an option',
    },
  ];

  const validators2 = [
    {
      fieldName: 'operatingPower',
      fieldValue: operatingPower,
      isValid: (v) => !isEmpty(v),
      errorMessage: () => 'Please select an option',
    },
    {
      fieldName: 'operatingPower_other',
      fieldValue: otherOperatingPower,
      isValid: (v) => !isEmpty(v) || operatingPower !== 'Other (please describe)',
      errorMessage: () => 'Please enter details',
    },
    {
      fieldName: 'maxSpeed',
      fieldValue: maxSpeed,
      isValid: isNumeric,
      errorMessage: (v) => (isEmpty(v) ? 'Please enter details' : 'Please enter only numeric value'),
    },
    {
      fieldName: 'maxAcceleration',
      fieldValue: maxAcceleration,
      isValid: isNumeric,
      errorMessage: (v) => (isEmpty(v) ? 'Please enter details' : 'Please enter only numeric value'),
    },
    {
      fieldName: 'maxResolvingSpeed',
      fieldValue: maxResolvingSpeed,
      isValid: (v) => isEmpty(v) || isNumeric(v),
      errorMessage: (v) => (isEmpty(v) ? 'Please enter details' : 'Please enter only numeric value'),
    },
    {
      fieldName: 'maxHeightPatron',
      fieldValue: maxHeightPatron,
      isValid: isNumeric,
      errorMessage: (v) => (isEmpty(v) ? 'Please enter details' : 'Please enter only numeric value'),
    },
    {
      fieldName: 'maxPatronSupportUnits',
      fieldValue: maxPatronSupportUnits,
      isValid: (v) => !isEmpty(v) && Number.isInteger(+v),
      errorMessage: (v) => (isEmpty(v) ? 'Please enter details' : 'Please enter only numeric value'),
    },
    {
      fieldName: 'maxAdultPatronsPerSupport',
      fieldValue: maxAdultPatronsPerSupport,
      isValid: (v) => !isEmpty(v) && Number.isInteger(+v),
      errorMessage: (v) => (isEmpty(v) ? 'Please enter details' : 'Please enter only numeric value'),
    },
    {
      fieldName: 'maxChildPatronsPerSupport',
      fieldValue: maxChildPatronsPerSupport,
      isValid: (v) => {
        return isEmpty(v) || Number.isInteger(+v);
      },
      errorMessage: (v) => (isEmpty(v) ? 'Please enter details' : 'Please enter only numeric value'),
    },
    {
      fieldName: 'minAgeUnAccompaniedPatron',
      fieldValue: minAgeUnAccompaniedPatron,
      isValid: isNumeric,
      errorMessage: (v) => (isEmpty(v) ? 'Please enter details' : 'Please enter only numeric value'),
    },
    {
      fieldName: 'minAgeAccompaniedPatron',
      fieldValue: minAgeAccompaniedPatron,
      isValid: (v) => isEmpty(v) || isNumeric(v),
      errorMessage: (v) => (isEmpty(v) ? 'Please enter details' : 'Please enter only numeric value'),
    },
    {
      fieldName: 'minPatronHeight',
      fieldValue: minPatronHeight,
      isValid: (v) => isEmpty(v) || isNumeric(v),
      errorMessage: (v) => (isEmpty(v) ? 'Please enter details' : 'Please enter only numeric value'),
    },
  ];

  const classOfDeviceOptions = Array.isArray(refData[RefData.amusementDevice.deviceClassOptions])
    ? refData[RefData.amusementDevice.deviceClassOptions].map((e) => ({
        value: e.value,
        label: e.description,
      }))
    : [];

  const mobilityTypeOptions = Array.isArray(refData[RefData.amusementDevice.mobilityTypeOptions])
    ? refData[RefData.amusementDevice.mobilityTypeOptions].map((e) => ({
        value: e.value,
        label: e.description,
      }))
    : [];

  const operatingPowerOptions = Array.isArray(refData[RefData.amusementDevice.operatingPowerOptins])
    ? refData[RefData.amusementDevice.operatingPowerOptins].map((e) => ({
        value: e.value,
        text: e.description,
      }))
    : [];

  if (ref) {
    ref.current = {
      validate: () => {
        return validateAll();
      },
    };
  }

  const validateAll = () => {
    let firstPartValid = validateExt(validators, setErrors, setErrorSummary);

    let secondPartValid = validateExt(validators2, setErrors2, setErrorSummary2);

    setShowErrors(!firstPartValid || !secondPartValid);

    let electricalInspectionDetailValid = true;
    let engineersInspectionDetailValid = true;

    if (electricalInstallation === 'yes' && electricalInspectionComponentRef.current) {
      electricalInspectionDetailValid = electricalInspectionComponentRef.current.validate();
    }

    if (engineersInspectionComponentRef.current) {
      engineersInspectionDetailValid = engineersInspectionComponentRef.current.validate();
    }

    return firstPartValid && secondPartValid && electricalInspectionDetailValid && engineersInspectionDetailValid;
  };

  const validateWithin1Year = (inspectionDate) => {
    if (moment(inspectionDate).isBefore(moment().subtract(1, 'year'))) {
      return 'Inspections are required to be completed within 12 months of the application date.';
    }
    return null;
  };

  const inspectionDateMore3MonthsWarn = (inspectionDate) => {
    if (/^\d{4}-\d{2}-\d{2}$/.test(inspectionDate)) {
      if (
        moment(inspectionDate).isBefore(moment().subtract(3, 'months')) &&
        moment(inspectionDate).isAfter(moment().subtract(12, 'months'))
      ) {
        return 'Please ensure that your next annual inspection is completed within 12 months of the last inspection date.';
      } else {
        return null;
      }
    }
  };

  const electricalInspectionComponentRef = React.useRef();
  const engineersInspectionComponentRef = React.useRef();

  const engineeringCertificateCode = refData.documentType.find(
    (d) => d.description === 'Engineering Inspection certificate',
  );
  const electricalCertificateCode = refData.documentType.find(
    (d) => d.description === 'Electrical Inspection certificate',
  );

  useEffect(() => {
    let details = {
      name,
      deviceClass,
      typeOfAmusementDevice,
      otherTypeOfAmusementDevice,
      mobilityType,
      electricalInstallation,
      operatingPower,
      otherOperatingPower,
      maxSpeed,
      maxAcceleration,
      maxResolvingSpeed,
      maxHeightPatron,
      maxPatronSupportUnits,
      maxAdultPatronsPerSupport,
      maxChildPatronsPerSupport,
      minAgeUnAccompaniedPatron,
      minAgeAccompaniedPatron,
      minPatronHeight,
      ...(electricalInstallation === 'yes' && { electricalInspectionDetails }),
      ...(electricalInstallation === 'no' && { electricalInspectionDetails: undefined }),
      engineerInspectionDetails,
      attachments,
    };
    onChange(details);

    if (showErrors) validateAll();
  }, [
    name,
    deviceClass,
    typeOfAmusementDevice,
    otherTypeOfAmusementDevice,
    mobilityType,
    electricalInstallation,
    operatingPower,
    otherOperatingPower,
    maxSpeed,
    maxAcceleration,
    maxResolvingSpeed,
    maxHeightPatron,
    maxPatronSupportUnits,
    maxAdultPatronsPerSupport,
    maxChildPatronsPerSupport,
    minAgeUnAccompaniedPatron,
    minAgeAccompaniedPatron,
    minPatronHeight,
    electricalInspectionDetails,
    engineerInspectionDetails,
    attachments,
  ]);

  useEffect(() => {
    onErrorChange(errorSummary.concat(electricalUploadErrorSummary, errorSummary2, engineersUploadErrorSummary));
  }, [errorSummary, errorSummary2, electricalUploadErrorSummary, engineersUploadErrorSummary]);

  return (
    <>
      <Row>
        <Col span={4}>
          <FormGroup
            id="name"
            label={PlantItemDetailsPage.relatedDetails.amusementDevice.nameOrDescriptionLabel}
            isRequired
            hasError={showErrors && errors?.name?.invalid}
            errorMessage={errors?.name?.errorMessage}
          >
            <Input
              onChange={(e) => {
                setName(e.target.value);
              }}
              value={name}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col span={6}>
          <FormRadioGroup
            id="deviceClass"
            name="deviceClass"
            legend={PlantItemDetailsPage.relatedDetails.amusementDevice.deviceClassLabel}
            options={classOfDeviceOptions}
            value={deviceClass}
            onChange={setDeviceClass}
            vertical={true}
            hasError={showErrors && errors?.deviceClass?.invalid}
            errorMessage={errors?.deviceClass?.errorMessage}
            margin={{ top: 'lg' }}
          />
        </Col>
      </Row>
      <Row>
        <Col span={4}>
          <FormRadioGroup
            id="mobilityType"
            name="mobilityType"
            legend={PlantItemDetailsPage.relatedDetails.amusementDevice.mobilityTypeTabel}
            options={mobilityTypeOptions}
            value={mobilityType}
            onChange={setMobilityType}
            vertical={true}
            hasError={showErrors && errors?.mobilityType?.invalid}
            errorMessage={errors?.mobilityType?.errorMessage}
            margin={{ top: 'lg' }}
          />
        </Col>
      </Row>

      <Row>
        <Col span={9}>
          <FormRadioGroup
            id="electricalInstallation"
            name="electricalInstallation"
            legend={PlantItemDetailsPage.relatedDetails.amusementDevice.electricalInstallationLabel}
            options={radioOptionsYesNo}
            value={electricalInstallation}
            onChange={setElectricalInstallation}
            vertical={true}
            hasError={showErrors && errors?.electricalInstallation?.invalid}
            errorMessage={errors?.electricalInstallation?.errorMessage}
            margin={{ top: 'lg' }}
          />

          {electricalInstallation === 'yes' && (
            <>
              <Heading level={3}>Electrical inspection certificate</Heading>
              <InPageAlert
                className={styles.pageAlert}
                variant="info"
                title="A detailed inspection of the device should be carried out by a competent person within the 3 months prior to the date of the application. A competent person is a person who has acquired through training, qualification or experience the knowledge and skills to inspect the device."
              >
                <p>
                  For class 4 and 5 amusement devices, a registered professional electrical engineer must inspect the
                  electrical installations of the device. For 2 or 3 devices the electrical installations of the device
                  must be inspected by a registered professional electrical engineer, or a holder of a Qualified
                  Supervisor (Electrical) certificate or Endorsed Contractor (Electrical) licence, or equivalent. The
                  person must be competent in the electrical/electronic systems used in the specific amusement device,
                  and in the application of the relevant requirements of AS 3533.
                </p>

                <p>
                  The inspection certificate can be downloaded{' '}
                  <a
                    href="https://www.safework.nsw.gov.au/__data/assets/pdf_file/0003/1069824/amusement-device-electrical-inspection-certificate.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    here
                  </a>
                  . You must upload this completed document to submit your application.
                </p>

                <p>Some of the details from the inspection certificate is required below.</p>
              </InPageAlert>
              <InspectionDocumentsUpload
                id="electricalInspection"
                ref={electricalInspectionComponentRef}
                value={electricalInspectionDetails}
                onChange={setElectricalInspectionDetails}
                validateInspectiondate={validateWithin1Year}
                applicationId={applicationId}
                onErrorChange={setElectricalUploadErrorSummary}
                warnInspectiondate={inspectionDateMore3MonthsWarn}
                supportingDocumentCode={electricalCertificateCode}
                description="Electrician Certificate"
                maxFiles={1}
              />
            </>
          )}
        </Col>
      </Row>
      <Row>
        <Col span={4}>
          <RadioOrDropdownSelector
            id="operatingPower"
            options={operatingPowerOptions}
            title={PlantItemDetailsPage.relatedDetails.amusementDevice.operatingPowerLabel}
            errorMessage={errors2?.operatingPower?.errorMessage}
            hasError={showErrors && errors2?.operatingPower?.invalid}
            onChange={(v) => {
              setOperatingPowwer(v);
              setOtherOperatingPower('');
            }}
            value={operatingPower}
            showExtraInput={operatingPower === 'Other (please describe)'}
            onChangeExtraInput={setOtherOperatingPower}
            extraInputValue={otherOperatingPower}
            extraInputErrorMessage={errors2?.operatingPower_other?.errorMessage}
            extraInputHasError={showErrors && errors2?.operatingPower_other?.invalid}
            extraInputTitle="Please describe"
            margin={{ top: 'lg' }}
          />
        </Col>
      </Row>
      <Row>
        <Col span={9}>
          <FormInput
            id="maxSpeed"
            label={PlantItemDetailsPage.relatedDetails.amusementDevice.maxSpeedLabel}
            suffix="m/s"
            onChange={(e, { value }) => setMaxSpeed(value)}
            value={maxSpeed}
            errorMessage={errors2?.maxSpeed?.errorMessage}
            hasError={showErrors && errors2?.maxSpeed?.invalid}
            margin={{ top: 'lg' }}
            className={styles.inputWithSuffix}
          />

          <FormInput
            id="maxAcceleration"
            label={PlantItemDetailsPage.relatedDetails.amusementDevice.maxAccelerationLabel}
            suffix="m/s&sup2;"
            onChange={(e, { value }) => setMaxAcceleration(value)}
            value={maxAcceleration}
            errorMessage={errors2?.maxAcceleration?.errorMessage}
            hasError={showErrors && errors2?.maxAcceleration?.invalid}
            className={styles.inputWithSuffix}
          />

          <FormInput
            id="maxResolvingSpeed"
            label={PlantItemDetailsPage.relatedDetails.amusementDevice.maxResolvingSpeedLabel}
            suffix="rpm"
            onChange={(e, { value }) => setMaxResolvingSpeed(value)}
            value={maxResolvingSpeed}
            errorMessage={errors2?.maxResolvingSpeed?.errorMessage}
            hasError={showErrors && errors2?.maxResolvingSpeed?.invalid}
            className={styles.inputWithSuffix}
          />

          <FormInput
            id="maxHeightPatron"
            label={PlantItemDetailsPage.relatedDetails.amusementDevice.maxHeightPatronLabel}
            suffix="m"
            onChange={(e, { value }) => setMaxHeightPatron(value)}
            value={maxHeightPatron}
            errorMessage={errors2?.maxHeightPatron?.errorMessage}
            hasError={showErrors && errors2?.maxHeightPatron?.invalid}
            className={styles.inputWithSuffix}
          />

          <FormGroup
            id="maxPatronSupportUnits"
            label={PlantItemDetailsPage.relatedDetails.amusementDevice.maxPatronSupportUnitsLabel}
            isRequired
            errorMessage={errors2?.maxPatronSupportUnits?.errorMessage}
            hasError={showErrors && errors2?.maxPatronSupportUnits?.invalid}
          >
            <Input
              onChange={(e) => {
                setMaxPatronSupportUnits(e.target.value);
              }}
              value={maxPatronSupportUnits}
              inputWidth="sm"
            />
          </FormGroup>

          <FormGroup
            id="maxAdultPatronsPerSupport"
            label={PlantItemDetailsPage.relatedDetails.amusementDevice.maxAdultPatronsPerSupportLabel}
            isRequired
            errorMessage={errors2?.maxAdultPatronsPerSupport?.errorMessage}
            hasError={showErrors && errors2?.maxAdultPatronsPerSupport?.invalid}
          >
            <Input
              onChange={(e) => {
                setMaxAdultPatronsPerSupport(e.target.value);
              }}
              value={maxAdultPatronsPerSupport}
              inputWidth="sm"
            />
          </FormGroup>

          <FormGroup
            id="maxChildPatronsPerSupport"
            label={PlantItemDetailsPage.relatedDetails.amusementDevice.maxChildPatronsPerSupportLabel}
            isRequired
            errorMessage={errors2?.maxChildPatronsPerSupport?.errorMessage}
            hasError={showErrors && errors2?.maxChildPatronsPerSupport?.invalid}
          >
            <Input
              onChange={(e) => {
                setMaxChildPatronsPerSupport(e.target.value);
              }}
              value={maxChildPatronsPerSupport}
              inputWidth="sm"
            />
          </FormGroup>

          <FormInput
            id="minAgeUnAccompaniedPatron"
            label={PlantItemDetailsPage.relatedDetails.amusementDevice.minAgeUnAccompaniedPatronLabel}
            onChange={(e, { value }) => setMinAgeUnAccompaniedPatron(value)}
            value={minAgeUnAccompaniedPatron}
            errorMessage={errors2?.minAgeUnAccompaniedPatron?.errorMessage}
            hasError={showErrors && errors2?.minAgeUnAccompaniedPatron?.invalid}
            suffix="years"
            className={styles.inputWithSuffix}
          />

          <FormInput
            id="minAgeAccompaniedPatron"
            label={PlantItemDetailsPage.relatedDetails.amusementDevice.minAgeAccompaniedPatronLabel}
            onChange={(e, { value }) => setMinAgeAccompaniedPatron(value)}
            value={minAgeAccompaniedPatron}
            errorMessage={errors2?.minAgeAccompaniedPatron?.errorMessage}
            hasError={showErrors && errors2?.minAgeAccompaniedPatron?.invalid}
            suffix="years"
            className={styles.inputWithSuffix}
          />

          <FormInput
            id="minPatronHeight"
            label={PlantItemDetailsPage.relatedDetails.amusementDevice.minPatronHeightLabel}
            onChange={(e, { value }) => setMinPatronHeight(value)}
            value={minPatronHeight}
            errorMessage={errors2?.minPatronHeight?.errorMessage}
            hasError={showErrors && errors2?.minPatronHeight?.invalid}
            suffix="cm"
            className={styles.inputWithSuffix}
          />

          <Heading level={3}>Engineers inspection certificate</Heading>
          <InPageAlert
            className={styles.pageAlert}
            variant="info"
            title="A detailed inspection of the device should be carried out by a competent person within the 3 months prior to the date of the application. A competent person is a person who has acquired through training, qualification or experience the knowledge and skills to inspect the device. The competent person must also be a registered professional engineer, except for continuously blown inflatable devices with a platform height less than 9m."
          >
            <p>
              The inspection certificate can be downloaded{' '}
              <a
                href="https://www.safework.nsw.gov.au/__data/assets/pdf_file/0004/1069825/amusement-device-mechanical-structural-inspection-certificate.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                here
              </a>
              . You must upload this completed document to submit your application.
            </p>

            <p>Some of the details from the inspection certificate is required below.</p>
          </InPageAlert>

          <InspectionDocumentsUpload
            id="engineersInspection"
            ref={engineersInspectionComponentRef}
            value={engineerInspectionDetails}
            onChange={setEngineerInspectionDetails}
            validateInspectiondate={validateWithin1Year}
            applicationId={applicationId}
            onErrorChange={setEngineersUploadErrorSummary}
            warnInspectiondate={inspectionDateMore3MonthsWarn}
            supportingDocumentCode={engineeringCertificateCode}
            description="Engineer Certificate"
            maxFiles={1}
          />
        </Col>
      </Row>
    </>
  );
});

AmusementDeviceDetails.displayName = 'AmusementDeviceDetails';
